// Merchant invitations (B4) — /api/stores/{store_id}/invites
// Records live on the store row (pending_invites); the signed invite URL is
// returned ONLY at creation time. Re-inviting an email supersedes (revokes)
// its previous pending invite.

import { apiClient } from './client'

export interface StoreInvite {
  invite_id: string
  email: string
  role: 'merchant'
  status: 'pending' | 'accepted' | 'revoked'
  invited_at: string
  invited_by: string
  accepted_at?: string
  revoked_at?: string
}

export async function listInvites(storeId: string): Promise<StoreInvite[]> {
  const res: any = await apiClient.get(`/api/stores/${storeId}/invites`)
  return res?.invites || []
}

export async function createInvite(
  storeId: string,
  email: string
): Promise<{ invite: StoreInvite; invite_url: string }> {
  const res: any = await apiClient.post(`/api/stores/${storeId}/invites`, { email })
  return { invite: res.invite, invite_url: res.invite_url }
}

export async function revokeInvite(storeId: string, inviteId: string): Promise<void> {
  await apiClient.delete(`/api/stores/${storeId}/invites?invite_id=${encodeURIComponent(inviteId)}`)
}
